export const FACEBOOK = 10;
export const TABOOLA = 18;
export const IRONSOURCE = 44;
export const BING = 46;
export const SNAPCHAT = 53;
export const REMERGE = 58;
export const ADIKTEEV = 59;
export const TIKTOK = 64;
export const MOLOCO = 77;
export const GOOGLE_ADS = 79;
export const YOUAPPI = 105;
export const APPLOVIN = 2;
export const TWITTER = 9;
export const DEV = 665;

export const PARTNERS = {
  [BING]: 'Bing',
  [FACEBOOK]: 'Facebook',
  [GOOGLE_ADS]: 'Google Ads',
  [SNAPCHAT]: 'Snapchat',
  [REMERGE]: 'Remerge',
  [ADIKTEEV]: 'Adikteev',
  [IRONSOURCE]: 'IronSource',
  [TABOOLA]: 'Taboola',
  [MOLOCO]: 'Moloco',
  [TIKTOK]: 'TikTok',
  [YOUAPPI]: 'YouAppi',
  [APPLOVIN]: 'AppLovin',
};

export const TAB_DETAILS = 'Details';
export const TAB_ACTIONS_LOG = 'Actions Log';
